export const NAMESPACE = 'flatBuilds';

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const TOGGLE_BUILD_CARD = `${NAMESPACE}/TOGGLE_BUILD_CARD`;
